import React from 'react';

import * as angular_web_components from '@brightlayerutilitycloud/angular-web-components/utilities-angular-web';
Object.entries(angular_web_components).forEach(([name, exported]) => window[name] = exported);

export function ResetPassword() {
    document.addEventListener('angularResendClicked', function (e) {
        if (e?.detail) {
            window.location.replace('/custom-forgot-password-route');
        }
    }, { capture: true });
    document.addEventListener('angularTryAgainClicked', function (e) {
        if (e?.detail) {
            window.location.replace('/custom-forgot-password-route');
        }
    }, { capture: true });
    // Detecting reset password continue or back click
    document.addEventListener('angularContinueClicked', function (e) {
        if (e?.detail) {
            window.location.replace('/login');
        }
    }, { capture: true });
    return (
        <div className="reset-password" data-testid="reset-pass">
            <div style={{ flex: '1 1 0px' }}>
                <reset-password-angular-comp />
            </div>
        </div>
    );
};
export default ResetPassword;